import { isService } from "../services/is_service";
import { useMutation } from "@tanstack/react-query";

export const useConnectWS = () => {
  const { mutate, mutateAsync, data, isLoading, error } = useMutation({
    mutationFn: async (data) => {
      const response = await isService.connectWS(data);
      return response;
    },
  });
  return { mutate, mutateAsync, data, isLoading, error };
};

export const useReadCard = () => {
  const { mutate, mutateAsync, data, isLoading, error } = useMutation({
    mutationFn: async (data) => {
      const response = await isService.readCard(data);
      return response;
    },
  });
  return { mutate, mutateAsync, data, isLoading, error };
};

export const useGetDeviceDetails = () => {
  const { mutate, mutateAsync, data, isLoading, error } = useMutation({
    mutationFn: async (data) => {
      const response = await isService.getDeviceDetails(data);
      return response;
    },
  });
  return { mutate, mutateAsync, data, isLoading, error };
};